import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import firebase from 'firebase/compat/app';
// import { getUserData } from "../users/getUserData";
import i18n from '../util/i18n'; // For changing the language
import { useTranslation } from 'react-i18next';


function SignInForm({email, password, encryptedA, encryptedB, isAuthenticated, setIsAuthenticated, setUidValue, debug}) {

    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
      const authenticateUser = async () => {
        let uidToCheck = null;
        let authenticated = false;

        // Si on a email et password dans l'URL, on fait une vraie authentification Firebase
        if (email && password) {
          try {
            const userCredential = await firebase.auth().signInWithEmailAndPassword(email, password);
            uidToCheck = userCredential.user.uid;
            authenticated = true;
            if (debug === true) console.log("Authentification Firebase réussie, UID:", uidToCheck);
          } catch (error) {
            console.log("Erreur d'authentification Firebase:", error.message);
            setErrorMessage(t('logout.error_id'));
            setUidValue(null);
            setIsAuthenticated(false);
            localStorage.removeItem('uid');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('client_type');
            localStorage.removeItem('timezone');
            localStorage.removeItem('encrypted_a');
            localStorage.removeItem('encrypted_b');
            return;
          }
        } else {
          // Pas de credentials dans l'URL, on vérifie les params chiffrés dans le localStorage
          console.log("No credentials in URL");
          const storedEncA = localStorage.getItem('encrypted_a');
          const storedEncB = localStorage.getItem('encrypted_b');
          const expirationDate = new Date(localStorage.getItem('expirationDate'));

          // Check if encrypted params are in localStorage and not expired
          if (!storedEncA || !storedEncB || expirationDate <= new Date()) {
            console.log("No encrypted params in localStorage or expired");
            setIsAuthenticated(false);
            navigate('/home');
            return;
          }

          // Déchiffrer les params stockés et re-authentifier avec Firebase
          try {
            const { decryptData } = await import('../util/decryption');
            const decryptedEmail = decryptData(storedEncA);
            const decryptedPassword = decryptData(storedEncB);

            if (!decryptedEmail || !decryptedPassword) {
              console.log("Failed to decrypt stored params");
              setIsAuthenticated(false);
              navigate('/deconnexion');
              return;
            }

            const userCredential = await firebase.auth().signInWithEmailAndPassword(decryptedEmail, decryptedPassword);
            uidToCheck = userCredential.user.uid;
            authenticated = true;
            if (debug === true) console.log("Re-authentification Firebase réussie, UID:", uidToCheck);
          } catch (error) {
            console.log("Re-authentification Firebase échouée:", error.message);
            setIsAuthenticated(false);
            localStorage.removeItem('encrypted_a');
            localStorage.removeItem('encrypted_b');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('uid');
            localStorage.removeItem('client_type');
            localStorage.removeItem('timezone');
            navigate('/deconnexion');
            return;
          }
        }

        // Si authentifié, sauvegarder dans localStorage
        if (authenticated) {
          const expirationDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
          localStorage.setItem('uid', uidToCheck);
          localStorage.setItem('expirationDate', expirationDate.toISOString());

          // Sauvegarder les valeurs chiffrées pour les liens vers gestion
          if (encryptedA && encryptedB) {
            localStorage.setItem('encrypted_a', encryptedA);
            localStorage.setItem('encrypted_b', encryptedB);
          }

          // Récupérer les données utilisateur depuis Firestore
          firebase.firestore().collection('customers').doc(uidToCheck).get()
          .then((doc) => {
            if (doc.exists) {
              const lang = doc.data().language;
              if (lang) {
                if (debug === true) console.log("langue de l'utilisateur (Firebase)", lang);
                i18n.changeLanguage(lang);
              }

              const client_type = doc.data().client_type;
              if (client_type) {
                localStorage.setItem('client_type', client_type);
              }

              const timezone = doc.data().timezone;
              if (timezone) {
                localStorage.setItem('timezone', timezone);
              }
            } else {
              const lang = navigator.language.split('-')[0];
              i18n.changeLanguage(lang);
            }
          })

          setUidValue(uidToCheck);
          setIsAuthenticated(true);

          // Redirect to home avec les paramètres chiffrés
          const storedA = localStorage.getItem('encrypted_a');
          const storedB = localStorage.getItem('encrypted_b');
          const authParams = `a=${encodeURIComponent(storedA)}&b=${encodeURIComponent(storedB)}`;

          if (debug === true) {
            navigate('/home?' + authParams + '&debug=true');
          } else {
            navigate('/home?' + authParams);
          }
        }
      };

      authenticateUser();
    }, [email, password, navigate, setIsAuthenticated, t, setUidValue, debug]);
   

    return (
      <>
        {errorMessage && (
          <div className="PhraseDisconnect">
            <p>{errorMessage}</p>
            <p>
              {t('logout.message')}{' '}
              {/* <a href="https://bv.elyote.com">{t('logout.link_message')}</a> */}
            </p>
          </div>
        )}
      </>
    );
}

export default SignInForm